import React, { useMemo } from 'react';
import {
  useSubscriptions,
  useSubscriptionsDispatch,
} from '@features/subscriptions/context/subscription-context';
import { FlexView, IconButton } from '@goodfynd/ui';
import { Text } from '@goodfynd/ui';
import { pluralize } from '@utils/string-util';

import type { SubscriptionProductQuantityProps } from './types';

import classes from './SubscriptionProducts.module.css';

export const SubscriptionProductQuantity = ({
  lineItem,
}: SubscriptionProductQuantityProps) => {
  const { activeSubscriptions } = useSubscriptions();
  const { removeCartItem, updateCartItem } = useSubscriptionsDispatch();

  const subscribedProduct = useMemo(() => {
    return activeSubscriptions
      .find((subscription) =>
        subscription.items.find((item) => item.price.sku === lineItem.sku)
      )
      ?.items.find((item) => item.price.sku === lineItem.sku);
  }, [activeSubscriptions, lineItem.sku]);

  return (
    <FlexView direction="column" gap={16} width="100%">
      <FlexView align="center" justify="space-between" width="100%">
        <IconButton
          className={classes['quantity-button']}
          disabled={!lineItem.quantity}
          icon="remove"
          size="small"
          onClick={() => {
            const newQuantity = lineItem.quantity - 1;
            if (!newQuantity && !subscribedProduct?.quantity) {
              removeCartItem(lineItem.sku);
              return;
            }

            updateCartItem({ ...lineItem, quantity: newQuantity });
          }}
        />

        <Text as="subhead2">{lineItem.quantity}</Text>

        <IconButton
          className={classes['quantity-button']}
          icon="add"
          size="small"
          onClick={() => {
            updateCartItem({ ...lineItem, quantity: lineItem.quantity + 1 });
          }}
        />
      </FlexView>

      {subscribedProduct && lineItem.previousQuantity && (
        <FlexView justify="center" width="100%">
          <Text as="body2">
            {lineItem.previousQuantity} current&nbsp;
            {pluralize('seat', lineItem.previousQuantity)}
          </Text>
        </FlexView>
      )}
    </FlexView>
  );
};
